/**
 * PLA-02 — Appartenance (rôle global réduit) vs métier sur le projet (role_projet).
 *
 * Miroir de backend/services/roles_service.py. Le rôle global ne dit plus que
 * l'appartenance : administrateur du cabinet, membre du cabinet ou externe. Ce que
 * la personne voit et fait sur un projet vient de son rôle projet
 * (GET /chantiers/{id} → role_projet, GET /chantiers/{id}/my-permissions).
 *
 * Les anciennes valeurs de `user.role` restent valides : `user.membership` (renseigné
 * par scripts/migrate_user_membership.py) est lu s'il existe, sinon recalculé.
 */

export const ROLE_PROJET_MOE = ['archi', 'moe_principal', 'moe_membre'];

const LEGACY_ROLE_MEMBERSHIP = {
  admin: 'admin_cabinet',
  architect: 'membre_cabinet',
  collaborateur: 'membre_cabinet', // RP32
  moe_principal: 'membre_cabinet',
  moe_membre: 'membre_cabinet',
  intervenant: 'externe',
  bet: 'externe',
  consultant: 'externe',
  amo: 'externe',
  client: 'externe',
  entreprise: 'externe',
  employe_entreprise: 'externe',
};

// Libellés : docs/REVUE-PRODUIT-2026-09/09-VOCABULAIRE.md §4
const ROLE_LABELS = {
  admin: 'Administrateur du cabinet',
  architect: 'Associé',
  collaborateur: 'Collaborateur', // RP32
  moe_principal: 'Chef de projet',
  moe_membre: 'Collaborateur',
  intervenant: 'Partenaire',
  bet: 'Partenaire',
  consultant: 'Partenaire',
  amo: 'AMO',
  client: 'Client (MOA)',
  entreprise: 'Entreprise',
  employe_entreprise: "Salarié de l'entreprise",
};

export function getMembership(user) {
  if (!user) return null;
  const computed = LEGACY_ROLE_MEMBERSHIP[user.role] || 'externe';
  const sourceOk = !user.membership_source_role || user.membership_source_role === user.role;
  if (user.membership && sourceOk) return user.membership;
  return computed;
}

export function isExterne(user) {
  return getMembership(user) === 'externe';
}

export function isEntrepriseRole(role) {
  return role === 'entreprise' || role === 'employe_entreprise';
}

export function roleLabel(role) {
  return ROLE_LABELS[role] || 'Utilisateur';
}
